import { useState } from 'react';
import { Divider, MenuItem, Select, SelectChangeEvent, Stack, Typography } from '@mui/material';
import SkeletonContainer from '../container/SkeletonContainer';
import AdsReceipt from './AdsReceipt';
import EyesIcon from '../icons/EyesIcon';
import FacebookPostPreview from './FacebookPostPreview';
import ReelPreview from './ReelPreview';
import { SocialMediaPlatformPreviews } from 'constants/enums/general';
import InstagramFeedPreview from './InstagramFeedPreview';

type Props = {
  loading: boolean;
  src: string;
};

const AdsPreview = (props: Props) => {
  const { loading, src } = props;
  const platforms = Object.values(SocialMediaPlatformPreviews);
  const [currentPlatform, setCurrentPlatform] = useState(SocialMediaPlatformPreviews.FACEBOOK_REEL);

  const handleSelect = (event: SelectChangeEvent) => {
    setCurrentPlatform(event.target.value as typeof currentPlatform);
  };

  const renderPreviews: Partial<Record<SocialMediaPlatformPreviews, React.ReactNode>> = {
    [SocialMediaPlatformPreviews.FACEBOOK_FEED]: (
      <FacebookPostPreview
        brandName="Danbolig"
        imageUrl={src}
        title="Title goes here"
        postText="Some engaging post text here... Explain all the great benefits of buying the property."
        websiteUrl="EFKT.COM"
      />
    ),
    [SocialMediaPlatformPreviews.FACEBOOK_REEL]: (
      <ReelPreview
        imageUrl={src}
        postText="Some engaging post text here..."
        type={SocialMediaPlatformPreviews.FACEBOOK_REEL}
      />
    ),
    [SocialMediaPlatformPreviews.INSTAGRAM_REEL]: (
      <ReelPreview
        imageUrl={src}
        postText="Some engaging post text here..."
        type={SocialMediaPlatformPreviews.INSTAGRAM_REEL}
      />
    ),
    [SocialMediaPlatformPreviews.INSTAGRAM_FEED]: <InstagramFeedPreview imageUrl={src} />,
  };

  return (
    <Stack justifyContent="space-between" gap={2}>
      <Stack gap="1.5rem">
        <Stack direction="row" alignItems="center">
          <Stack direction="row" gap={0.75} flex={1} alignItems="center">
            <EyesIcon height="2rem" />
            <Typography variant="h6">Example view</Typography>
          </Stack>
          <Select sx={{ flex: 1, height: '2.5rem' }} variant="outlined" value={currentPlatform} onChange={handleSelect}>
            {platforms.map(platform => (
              <MenuItem key={platform} value={platform}>
                {platform}
              </MenuItem>
            ))}
          </Select>
        </Stack>
        <SkeletonContainer loading={loading} rows={{ xs: 1 }} columns={{ xs: 1 }}>
          {renderPreviews[currentPlatform]}
        </SkeletonContainer>
      </Stack>
      <Divider />
      <AdsReceipt src={src} />
    </Stack>
  );
};

export default AdsPreview;
